<template>
  <div class="w-full">
    <vx-card class="w-full mb-5 user-details">
    <div class="flex flex-wrap mb-16">
      <div class="w-full mb-10 md:w-3/5 md:m-0 flex">
        <div class="relative float-left mr-5">
          <vs-avatar size="90px" :src="userAvatarUrl"/>
          <div v-if="user.blockedOnAccount" class="red-dot">
          </div>
          <div v-else class="green-dot">
          </div>
        </div>
        <div class="float-left">
          <p class="font-medium text-lg leading-loose mb-2 mt-1">{{ user.name }}</p>
          <div class="text-lg leading-normal mb-2"> {{ user.email }}</div>
          <p class="text-lg leading-6 font-hairline text-gray-500">
            Status: <span v-if="user.blockedOnAccount" class="blocked-color">Blocked</span>
            <span v-else class="active-color">Active</span>
          </p>
        </div>
      </div>
      <div v-if="activeUserInfo.id != user.id" class="w-full md:w-2/5">
        <vs-button class="leading-normal font-medium w-full md:w-auto md:float-right border-2 block-btn py-2"
        v-if="!user.blockedOnAccount"
        color="danger"
        icon-pack="speakol"
        icon="speakol-block"
        @click="showBlockConfirmationPopup = true"
        type="border">Block
        </vs-button>

        <vs-button class="leading-normal font-medium w-full md:w-auto md:float-right border-2 block-btn py-2"
        v-if="user.blockedOnAccount"
        color="danger"
        icon-pack="speakol"
        icon="speakol-block"
        @click="showBlockConfirmationPopup = true"
        type="border">Unblock
        </vs-button>

      </div>
    </div>
    <div class="w-full md:flex mb-10 justify-between">
      <div class="w-full md:w-1/4">
        <h2 class="textHeader w-full mb-5 md:mb-0">Roles and Permissions</h2>
      </div>
      <div class="w-full md:w-1/4 flex">
        <span class="font-bold block w-full pt-2 md:text-right md:pr-10" v-if="!$can('invite_super_admin')">Role: <b
          class="pl-5">{{ convertSnakeCaseToSentenceCase(user.role) }}</b></span>
        <span class="font-bold block w-full pt-2 md:w-1/6 " v-if="$can('invite_super_admin')">Role:</span>
        <v-select
          v-if="$can('invite_super_admin')"
          id="settings-users-filter-by-list"
          label="text"
          :options="rolesOptionsObjForFilter()"
          :clearable="false"
          class="md:w-5/6"
          v-model="currentRole"
        ></v-select>
      </div>
    </div>
    <vs-table class="mb-10" stripe :data="currentRolePermissions">
      <template slot="thead">
        <vs-th class="md:w-11/12 w-1/2 pl-10 text-lg">
          Permissions
        </vs-th>
        <!-- <vs-th class="md:w-1/12 w-1/2 pl-10 text-lg">
          Status
        </vs-th> -->
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <td class="pl-10 text-lg">{{ convertSnakeCaseToSentenceCase(tr) }}</td>
          <!-- <td class="pl-10">
            <div v-if="user.permissions.includes(tr)">
              <vs-switch value="true"/>
            </div>
            <div v-else>
              <vs-switch/>
            </div>
          </td> -->
        </vs-tr>
      </template>
    </vs-table>
  </vx-card>
    <speakol-response-popup
      v-on:hide-response-popup="responsePopupData.show = false"
      :responsePopupData="responsePopupData"
    />
  <speakol-confirmation-popup
      v-on:hide-confirmation-popup="showBlockConfirmationPopup = false"
      v-on:confirm="user.blockedOnAccount ? unblockUser() : blockUser()"
      :showConfirmationPopup="showBlockConfirmationPopup"
      :title="'Confirmation'"
      :body="confirmationPopupBody"
    />
  </div>
</template>

<script>
import { get } from 'lodash'

export default {
  async created () {
    try {
      this.user = await this.getUser()
      this.currentRole = {text: this.convertSnakeCaseToSentenceCase(this.user.role), value: this.user.role}
      this.currentRolePermissions = await this.getALlPermissions(this.user.role)

    } catch (error) {
      //Handle error
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.getters['authentication/user']
    },
    confirmationPopupBody () {
      if (this.user.blockedOnAccount) {
        return `Are you sure you want to unblock ${this.user.name} ?`
      } else {
        return `Are you sure you want to block ${this.user.name} ?`
      }
    },
    userAvatarUrl () {
      return get(this.user, 'media[0].url', '')
    }
  },
  methods: {
    convertSnakeCaseToSentenceCase (str) {
      if (!str) return
      return str.split('_').map(function (item) {
        return item.charAt(0).toUpperCase() + item.substring(1)
      }).join(' ')
    },
    async getALlPermissions (role) {
      return (await window.axios.get(`/roles/${role}/permissions`)).data
    },
    async getUser () {
      return  (await window.axios.get(`/users/${this.$route.params.id}`)).data

    },
    async blockUser () {

      try {
        await window.axios.post(`/users/${this.$route.params.id}/block-user-account`)
        this.showBlockConfirmationPopup = false
        this.user.blockedOnAccount = true
        this.successToggleBlock()
      } catch (error) {
        this.failToggleBlock()
      }

    },
    async editUserRole (newRole) {

      try {
        const response = await window.axios.post(
          `/users/${this.$route.params.id}/edit-role-user-account`,
          {userId: this.user.id, newRole}
        )

        if (response.status === 200) {
          this.user = response.data.payload
          this.currentRole = {text: this.convertSnakeCaseToSentenceCase(this.user.role), value: this.user.role}
          this.currentRolePermissions = await this.getALlPermissions(this.user.role)
        } else {
          this.sendExceptionToSentry(response)
        }
      } catch (error) {
        this.sendExceptionToSentry(error)
      }
    },
    async unblockUser () {

      try {
        await window.axios.post(`/users/${this.$route.params.id}/unblock-user-account`)
        this.showBlockConfirmationPopup = false
        this.user.blockedOnAccount = false
        this.successToggleBlock()
      } catch (error) {
        this.failToggleBlock()
      }

    },
    successToggleBlock () {
      this.responsePopupData.show = true
      this.responsePopupData.type = 'success'
      this.responsePopupData.body = `You have successfully ${this.user.blockedOnAccount  ? 'blocked' : 'unblocked' } ${this.user.name}`
    },
    failToggleBlock () {
      this.responsePopupData.show = true
      this.responsePopupData.type = 'error'
      this.responsePopupData.body = 'Something went wrong!'
    },
    rolesOptionsObjForFilter () {
      const roles = []
      if (!this.$can('invite_editor')) {
        return [
          {
            text: 'All',
            value: 'all'
          },
          {
            text: 'Admin',
            value: 'admin'
          },
          {
            text: 'Editor',
            value: 'editor'
          },
          {
            text: 'Viewer',
            value: 'viewer'
          }
        ]
      }

      if (this.$can('invite_super_admin')) {
        roles.push({
          text: 'Super Admin',
          value: 'super_admin'
        })
        roles.push({
          text: 'Account manager',
          value: 'account_manager'
        })
        roles.push({
          text: 'Finance',
          value: 'finance'
        })
      }
      if (this.$can('invite_admin')) roles.push({
        text: 'Admin',
        value: 'admin'
      })
      if (this.$can('invite_editor')) roles.push({
        text: 'Editor',
        value: 'editor'
      })
      if (this.$can('invite_viewer')) roles.push({
        text: 'Viewer',
        value: 'viewer'
      })
      return roles
    },
    sendExceptionToSentry (error) {
      if (!window.axios) {
        return
      }
      
      window.axios.sendHandledSentryException(error)
    }
  },
  watch: {
    currentRole (newVal, oldVal) {
      if (newVal && oldVal && newVal.value !== oldVal.value) {
        this.editUserRole(newVal.value)
      }
    }
  },
  mounted () {
    this.$parent.setupTabsBar()
  },
  data () {
    return {
      showBlockConfirmationPopup: false,
      responsePopupData: {
        show: false
      },
      user: {
        permissions: [],
        blockedOnAccount: false
      },
      currentRole: null,
      currentRolePermissions: []

    }
  }
}

</script>

<style lang="scss" scoped>

.green-dot {
  background: #2dcd7a;
  width: 18px;
  height: 18px;
  position: absolute;
  bottom: 10px;
  left: 77px;
  top: 68px;
  border-radius: 50%;
  border: 2px solid white;
}

.red-dot {
  background: #db2828;
  width: 18px;
  height: 18px;
  position: absolute;
  bottom: 10px;
  left: 77px;
  top: 68px;
  border-radius: 50%;
  border: 2px solid white;
}

.active-color {
  color: #2dcd7a;
}

.blocked-color {
  color: #f00;
}

.textHeader {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.1px;
  color: #2c2c2c;
}

.user-details {
  letter-spacing: 0.107143px;
  color: #2c2c2c;
}

.block-btn {
  border: 2px solid #d9d8d8 !important;
}

th {
  background: rgba(0, 146, 215, 0.06);
}

</style>
